































































































































































import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import {
  ImageStatus,
  JbicImage,
  JbicImageVersion
} from '@/store/modules/admin/types/admin.types';
import dayjs from 'dayjs';

@Component({
  components: {}
})
export default class EditImageSidebar extends Vue {
  @Prop() image!: JbicImage;
  @Prop() imageVersion!: JbicImageVersion | undefined;
  @Prop({ default: false }) isSidebarOpen!: boolean;
  @Prop({ default: true }) readOnly!: boolean;

  imageCaption: string = '';
  imageAlternateText: string = '';
  imageVersionCaption: string = '';
  imageVersionAlternateText: string = '';
  imageVersionUrl: string = '';
  isReadOnly: boolean = true;
  public currentImage: JbicImage = {
    id: 0,
    imageUrl: '',
    alternateText: '',
    caption: '',
    status: ImageStatus.DRAFT,
    groupId: 0,
    createdAt: new Date(),
    createdBy: {
      userId: 0,
      email: '',
      emailVerified: false,
      firstName: '',
      lastName: '',
      type: '',
      status: '',
      username: ''
    }
  };

  get closeButtonLabel() {
    return this.isReadOnly ? 'Close' : 'Cancel';
  }

  get titleLabel() {
    return this.isReadOnly ? 'View' : 'Manage';
  }

  get updatedLabelByStatus() {
    const statusMap = {
      [ImageStatus.DRAFT]: 'Uploaded',
      [ImageStatus.APPROVED]: 'Approved',
      [ImageStatus.DECLINED]: 'Denied',
      [ImageStatus.PUBLISHED]: 'Published',
      [ImageStatus.AWAITING_APPROVAL]: 'Updated'
    };
    return statusMap[this.currentImage.status] || 'Updated';
  }

  get createdByLabel() {
    return `${this.updatedLabelByStatus} by`;
  }

  get createdAtLabel() {
    return `${this.updatedLabelByStatus} at`;
  }

  get imageUrl() {
    return this.currentImage?.imageUrl;
  }

  get imageCreatedByUsername() {
    return this.currentImage?.createdBy?.username;
  }

  get imageCreatedAt() {
    return this.currentImage?.createdAt;
  }

  get isPublished(): boolean {
    return this.currentImage?.status === ImageStatus.PUBLISHED;
  }

  get isDeclined(): boolean {
    return this.currentImage?.status === ImageStatus.DECLINED;
  }

  get isAwaitingApproval(): boolean {
    return this.currentImage?.status === ImageStatus.AWAITING_APPROVAL;
  }

  get publishedMessage() {
    return `<p>
              <b>
                Image Published
              </b>
            </p>
            <p>
              This image is published and can't be edited directly. To make changes, unpublish it and it will be moved to the DRAFT tab.
            </p>`;
  }

  get declinedMessage() {
    return `<p>
              <b>
                Image Denied
              </b>
            </p>
            <p>
              Reason for Denying: ${this.currentImage.declinedReason}
            </p>`;
  }

  onSidebarCloseModal() {
    this.$emit('toggleSidebar', false);
  }

  onUpdateImageDetails() {
    this.currentImage.caption = this.imageCaption;
    this.currentImage.alternateText = this.imageAlternateText;
    this.$emit('updateImageDetails', this.currentImage);
  }

  formatDate(date: Date) {
    if (!date) {
      return '';
    }

    return dayjs(date).format('D MMM YYYY, h:mm A');
  }

  showPreviousVersion(previousValue: string, currentValue: string): boolean {
    if (!this.isAwaitingApproval) {
      return false;
    }

    if (!previousValue || previousValue.length === 0) {
      return false;
    }

    if (!currentValue || currentValue.length === 0) {
      return false;
    }

    if (previousValue === currentValue) {
      return false;
    }

    return true;
  }

  @Watch('image')
  onImage() {
    this.currentImage = JSON.parse(JSON.stringify(this.image));
    this.imageCaption = this.currentImage?.caption;
    this.imageAlternateText = this.currentImage?.alternateText;

    if (this.isPublished) {
      this.isReadOnly = true;
    }
  }

  @Watch('imageVersion')
  onImageVersion() {
    this.imageVersionCaption = this.imageVersion?.caption ?? '';
    this.imageVersionAlternateText = this.imageVersion?.alternateText ?? '';
    this.imageVersionUrl = this.imageVersion?.imageUrl ?? '';
  }

  @Watch('readOnly')
  onReadOnly() {
    this.isReadOnly = this.readOnly;
  }
}
